import React from 'react';
import { ArrowLeft, Check, RefreshCw } from 'lucide-react';

export default function ShadePhotoReview({ previewUrl, onUse, onChooseAgain }) {
  return (
    <div className="fixed inset-0 z-[210] flex items-end sm:items-center justify-center bg-black/45 p-4" role="dialog" aria-modal="true" aria-labelledby="shade-photo-review-title">
      <div className="w-full max-w-sm overflow-hidden rounded-3xl bg-[#FCF8F4] shadow-2xl">
        <div className="p-5 pb-4">
          <button type="button" onClick={onChooseAgain} className="mb-3 inline-flex items-center gap-1 border-0 bg-transparent p-0 text-sm font-semibold text-[#755E53]">
            <ArrowLeft size={16} aria-hidden="true" /> Back
          </button>
          <p className="mb-1 text-sm font-bold tracking-wide text-[#A66E54]">SHADE PHOTO</p>
          <h2 id="shade-photo-review-title" className="m-0 font-serif text-4xl font-medium leading-tight text-[#2D1515]">Check this photo</h2>
          <p className="mt-3 text-[15px] leading-relaxed text-[#786B65]">Before matching, make sure the colour in this image looks true to life.</p>
        </div>

        <div className="mx-5 aspect-[4/3] overflow-hidden rounded-2xl bg-[#EFE6DE]">
          <img src={previewUrl} alt="Selected skin reference" className="h-full w-full object-cover" />
        </div>

        <ul className="mx-5 my-4 grid list-none gap-2 p-0 text-sm text-[#5C453B]">
          {['Soft, even light', 'Skin is sharp and in focus', 'No filter or strong colour cast'].map((item) => (
            <li key={item} className="flex items-center gap-2"><span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#EFE0D5] text-[#764530]"><Check size={13} aria-hidden="true" /></span>{item}</li>
          ))}
        </ul>

        <p className="mx-5 mb-4 rounded-2xl bg-[#F3E8DE] px-4 py-3 text-[13px] leading-relaxed text-[#685850]">This photo will be used only for shade matching. It will not create a face or skin analysis.</p>

        <div className="grid gap-2 p-5 pt-0">
          <button type="button" onClick={onUse} className="w-full rounded-full border-0 bg-[#3A1B1B] px-5 py-4 text-base font-bold text-white">Use this photo</button>
          <button type="button" onClick={onChooseAgain} className="inline-flex w-full items-center justify-center gap-2 rounded-full border border-[#D8CBC1] bg-white px-5 py-3 text-sm font-bold text-[#5C453B]"><RefreshCw size={15} aria-hidden="true" /> Choose another</button>
        </div>
      </div>
    </div>
  );
}
